import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';
import { Text } from '../../Text/Text';

interface CollapsableDescriptionProps {
    active?: boolean;
}

export const CollapsableDescription = styled(Text)<CollapsableDescriptionProps>`
    color: ${(props) => (props.active ? theme.colors.accent.foreground : theme.colors.foreground.muted)};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;
